import React from 'react';
import {
    Chart as ChartJS,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    type BarControllerChartOptions,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

export type ChartJsBarDataType = {
    labels: string[];
    datasets: {
        label: string;
        data: number[];
        backgroundColor: string[];
        borderColor?: string[];
        borderWidth?: number;
    }[];
};

type ChartJsBarProps = {
    data: ChartJsBarDataType;
    optionsProps?: BarControllerChartOptions;
    direction?: 'x' | 'y';
    displayLegend?: boolean;
    displayTitle?: boolean;
    title?: string;
};

const ChartJsBar: React.FunctionComponent<ChartJsBarProps> = function ({
    data,
    optionsProps,
    displayLegend = true,
    displayTitle = false,
    title,
    direction = 'x',
}) {
    ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top' as const,
                display: displayLegend,
            },
            title: {
                display: displayTitle,
                text: title,
            },
        },
        indexAxis: direction,
        ...optionsProps,
    };

    return (
        <Bar
            options={options}
            data={data}
        />
    );
};

export default ChartJsBar;
